import { PropsWithChildren, useEffect } from "react";
import { ExerciseType } from "@/components/v3/exercises/ExerciseBadge";
import useGlobals from "@/utils/hooks/useGlobals.ts";
import LayoutHeaderMobile from "@/components/v3/exercises/LayoutHeaderMobile";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";

type Props = {
  type?: ExerciseType;
  title?: string;
  timer?: number;
  onClose?: () => void;
  audioSrc?: string;
  onSubmit?: () => void;
  isGrammar?: boolean;
  inProgress?: boolean;
  isCorrection?: boolean;
  isTimerVisible?: boolean;
  onViewEssayByTutor?: () => void;
};

export default function ExerciseLayoutMobile({
  type = ExerciseType.READING,
  title = "Multiple choice and matching options (pt.2)",
  timer,
  onClose,
  children,
  isGrammar,
  isTimerVisible,
}: PropsWithChildren<Props>) {
  const { setGlobalState } = useGlobals();

  useEffect(() => {
    setGlobalState("showSideBar", false);
    setGlobalState(
      "backgroundClass",
      "bg-brand-background from-[rgb(46,0,79)] via-[rgb(59,0,102)] to-[rgb(0,69,74)]",
    );

    return () => {
      setGlobalState("showSideBar", true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardContentLayout>
      <div className="flex flex-col h-full">
        <LayoutHeaderMobile
          type={type}
          title={title}
          timer={timer}
          onClose={onClose}
          isGrammar={isGrammar}
          isTimerVisible={isTimerVisible}
        />
        <div
          className="flex rounded-[15px] p-4 flex-col w-full relative h-full px-2"
          style={{ maxHeight: "calc(100vh - 130px)" }}
        >
          <div className={"flex flex-col w-full relative h-full"}>
            {children}
          </div>
        </div>
      </div>
    </DashboardContentLayout>
  );
}
